import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./OurServices.css"; 
  import Img1 from '../../images/Image-1.jpg'
  import Img2 from '../../images/Image-2.jpg'
  import Img3 from '../../images/Image-3.jpg'
  import Img4 from '../../images/Image-4.jpg'
  import Img5 from '../../images/Image-5.jpg'
  import Img6 from '../../images/Image-6.jpg'
  import care1 from '../../images/Homecare.jpg'
  import care2 from '../../images/ToSellCareHome.jpg'
  import Acco1 from '../../images/Accounts-1.jpg'
  import Acco2 from '../../images/ToSellCareHome.jpg'
  import Acco3 from '../../images/Allowances.jpg'
  import Acco4 from '../../images/FinancialAnalysis.jpg'
  import Soft1 from '../../images/rotacare.jpg'
  import Soft2 from '../../images/Governance Software.jpg'
  import Soft3 from '../../images/Care Audit Software.jpg'
  import Soft4 from '../../images/Our ERP System.jpg'
  import Soft5 from '../../images/Capital allowances.jpg'
  import Opra1 from '../../images/New Business Set Up.jpg'
  import Opra2 from '../../images/Full Operational Management.jpg';




const Services = () => {

  const handleSeeMore = () => {
    navigate("/", {
      state: { scrollToContact: true },
    });
  };


const scrollToSection = (sectionId) => {
  setActiveSection(sectionId);

  setTimeout(() => {
    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 100);
};


    // open page on top //
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    // open page on top // 

const navigate = useNavigate();

const navigateToService = (section) => {
  navigate("/services", {
    state: {
      activeSection: section,
    },
  });
};

 const handleReadMoreCQ1 = () => {
    navigate("/registration");
  };
   const handleReadMoreCQ2 = () => {
    navigate("/Sub-Pages/CQC_Mock");
  };
   const handleReadMoreCQ3 = () => {
    navigate("/Sub-Pages/CQC_Support");
  };
   const handleReadMoreCQ4 = () => {
    navigate("/Sub-Pages/CQC_Occupancy");
  };
   const handleReadMoreCQ5 = () => {
    navigate("/Sub-Pages/CQC_Training");
  };
  const handleReadMoreCA1 = () => {
  navigate("/Sub-Pages/Care_Sale");
  };
   const handleReadMoreCA2 = () => {
    navigate("/Sub-Pages/Care_Sell");
  };

   const handleReadMoreAC1 = () => {
    navigate("/Sub-Pages/Acc_Endof");
  };
  const handleReadMoreAC2 = () => {
    navigate("/Sub-Pages/Acc_Payroll");
  };
  const handleReadMoreAC3 = () => {
    navigate("/Sub-Pages/Acc_Capital");
  };
  const handleReadMoreAC4 = () => {
    navigate("/Sub-Pages/Acc_Financial");
  };
 const handleReadMoreSoft1 = () => {
    navigate("/Sub-Pages/Soft_Rota");
  };
  const handleReadMoreSoft2 = () => {
    navigate("/Sub-Pages/Soft_Governance");
  };
  const handleReadMoreSoft3 = () => {
    navigate("/Sub-Pages/Soft_Audit");
  };
  const handleReadMoreSoft4 = () => {
    navigate("/Sub-Pages/Soft_ERP");
  };
  const handleReadMoreSoft5 = () => {
    navigate("/Sub-Pages/Soft_Allowances");
  };
  const handleReadMoreOpra1 = () => {
    navigate("/Sub-Pages/Opera_Setup");
  };
    const handleReadMoreOpra2 = () => {
    navigate("/Sub-Pages/Opera_fullManag");
  };

  const location = useLocation();
  const [activeSection, setActiveSection] = useState("cqc-services");

  useEffect(() => {
    if (location.state?.activeSection) {
      setActiveSection(location.state.activeSection);
    }
  }, [location]);

  return (
    <section className="OurServices">
                <h1 className="OurServices-title">Building Confidence in Compliance</h1>
              <p className="OurServices-pera">Total Care Advisory delivers trusted consultancy that care providers can rely on when it matters most.<br/><br/>
              We understand the pressures of a busy care environment and provide expert guidance that helps services stay compliant, improve standards, and 
              move forward with confidence.</p>
              <div className="btn-container">
                 <button className="OurServices-btn">
                   <a link href="https://flipbook.so/flip/jUUmHzGAoWFTRgkf2a8U">link to Brochure</a>
                 </button>
                 </div>
               <section className="our-services">
                 <h2 className="our-services__heading">Services</h2>

               <p className="our-services__description">
                 We offer a range of specialized services tailored to meet your individual
                 needs. Our approach is focused on understanding
                 <br />
                   and responding to what you require, providing effective and practical
                 solutions.
                 </p>

                 <div className="our-services__container">
                   <div className="our-services__list">

                   <div className="our-services__item">
                     <div className="service-card">
                       <div className="service-card__image service-card__CQCServices"></div>

                      <div className="service-card__content">
                         <div className="service-card__title">CQC Services</div>

                         <p className="service-card__text">
                           We can support with the complexities of compliance and regulation!
                         </p>
                       <div className="btn-container">
                      <button onClick={() => scrollToSection("cqc-services")}
                      id="Service-btn"className={activeSection === "cqc-services" ? "active" : ""}>Read More</button>                          
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="our-services__item">
                    <div className="service-card">
                      <div className="service-card__image service-card__CareHomeSales"></div>

                      <div className="service-card__content">
                        <div className="service-card__title">Care Home Sales</div>

                        <p className="service-card__text">
                          Professional support for buying, selling, and valuing care homes.
                        </p>
                      <div className="btn-container">
                      <button onClick={() => scrollToSection("care-home-sales")}
                      id="Service-btn"className={activeSection === "care-home-sales" ? "active" : ""}>Read More</button>
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="our-services__item">
                    <div className="service-card">
                      <div className="service-card__image service-card__Accounting"></div>

                      <div className="service-card__content">
                        <div className="service-card__title">Accounting</div>

                        <p className="service-card__text">
                        Financial management, bookkeeping, payroll, and tax services.
                        </p>
                      <div className="btn-container">
                     <button onClick={() => scrollToSection("accounting")}
                    id="Service-btn"className={activeSection === "accounting" ? "active" : ""}>Read More</button>
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="our-services__item">
                    <div className="service-card">
                      <div className="service-card__image service-card__Software"></div>

                      <div className="service-card__content">
                        <div className="service-card__title">Software</div>

                        <p className="service-card__text">
                        Digital solutions designed to streamline care operations.
                        </p>
                        <div className="btn-container">
                      <button onClick={() => scrollToSection("software")}
                    id="Service-btn"className={activeSection === "software" ? "active" : ""}>Read More</button>
                    </div>
                      </div>
                    </div>
                  </div>
                  <div className="our-services__item">
                    <div className="service-card">
                      <div className="service-card__image service-card__OperationalManagement"></div>

                      <div className="service-card__content">
                        <div className="service-card__title">Operational Management</div>

                        <p className="service-card__text">
                        Guidance and support to improve efficiency and quality.
                        </p>
                        <div className="btn-container">
                         <button onClick={() => scrollToSection("operational-management")}
                          id="Service-btn"className={activeSection === "operational-management" ? "active" : ""}>Read More</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
               </section>
      
      {activeSection === "Services-Home-page"  && (
       <div className="detail-content" id="Serv">
        <div className="Support-page">
         <div className="Support-card">
          <h1 className="Support-title">We can also support with...</h1>
           <div className="Support-container">

                             <section className="Support-section">
                                 <div className="Support-image">
                                     <img src={Img1} alt="" />
                                 </div>
                                <div className="Support-box">
                                    <h2>CQC Services</h2>
                                    <p> Our expert consultants guide you through every stage of the Care Quality Commission (CQC) process, from registration 
                                      and compliance to inspections and ongoing quality improvement. We help ensure your service meets regulatory standards with confidence.</p>
                                      <button  onClick={() => navigateToService("cqc-services")}
                                        id="Service-btn" className={activeSection === "cqc-services" ? "active" : ""}>
                                            Read More </button>
                                      
                                </div>
                            </section>
                              <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={care1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Care Home Sales</h2>
                                    <p> Our Care Home Sales service provides expert guidance throughout the buying and selling process, helping owners 
                                      maximise value, ensure compliance, and achieve smooth, confidential transactions with confidence and clarity.</p>
                                      <button  onClick={() => navigateToService("care-home-sales")}
                                        id="Service-btn" className={activeSection === "care-home-sales" ? "active" : ""}>
                                            Read More </button>
                                </div>
                            </section>
                            <section className="Support-section ">
                                <div className="Support-image">
                                    <img src={Acco1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Accountancy Services </h2>
                                    <p> Our specialist Accountancy Services for the care industry provide tailored financial support, helping providers manage
                                        finances efficiently, maintain compliance, improve profitability, and make informed decisions for sustainable long-term growth.</p>
                                       <button  onClick={() => navigateToService("accounting")}
                                        id="Service-btn" className={activeSection === "accounting" ? "active" : ""}>
                                            Read More </button>
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Soft1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Software</h2>
                                    <p> Our care sector software solutions streamline scheduling, governance, auditing. Our full ERP system provides all-round 
                                      efficiency to maintain compliance, enhance oversight, and deliver better outcomes across their organisations.</p>
                                      <button  onClick={() => navigateToService("software")}
                                        id="Service-btn" className={activeSection === "software" ? "active" : ""}>
                                            Read More </button>
                                </div>
                            </section>
                              <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Opra1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Training </h2>
                                    <p> We deliver face-to-face training for care professionals, covering moving and handling, medication, fire safety, and first aid,
                                        helping teams build confidence, stay compliant, and deliver safe, high-quality care.</p>
                                      <button  onClick={() => navigateToService("operational-management")}
                                        id="Service-btn" className={activeSection === "operational-management" ? "active" : ""}>
                                            Read More </button>
                                </div>
                            </section>
                        </div>
                    </div>
            </div>
              </div>
      )}
      {activeSection === "cqc-services" && (
       <div className="detail-content" id="cqc-services">
                  <div className="Support-page">
                     <div className="Support-card">
                         <h1 className="Support-title">CQC Services</h1>
                         <div className="Support-container">
                            <section className="Support-section">
                                 <div className="Support-image">
                                     <img src={Img1} alt="" />
                                 </div>
                                <div className="Support-box">
                                    <h2>CQC Registration</h2>
                                    <p>Starting a care service can be a complex process, but our CQC Registration support makes it straightforward. We assist with applications, 
                                      policies, procedures, statement of purpose, and regulatory requirements, ensuring your service is fully prepared to meet CQC standards from day one.</p>
                                        <button className="OurServices-btn" onClick={handleReadMoreCQ1}>Read More</button>
                                        
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Img2} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Mock Inspections</h2>
                                    <p>Our comprehensive Mock Inspection service mirrors the CQC inspection process, providing a realistic assessment of your 
                                      service. We identify strengths, highlight areas requiring improvement, and deliver practical recommendations to help 
                                      you achieve better inspection outcomes and maintain compliance.</p>
                                       <button className="OurServices-btn" onClick={handleReadMoreCQ2}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Img3} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Management Support Services</h2>
                                    <p>Effective leadership is essential for delivering high-quality care. Our Management Support Services provide expert
                                        guidance on operational management, governance, compliance, quality assurance, staffing, and performance improvement
                                        to help your service run efficiently and confidently.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreCQ3}>Read More</button>
                                </div>
                            </section>
                              <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Img4} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Maximising Occupancy </h2>
                                    <p>Maintaining strong occupancy levels is key to the success and sustainability of any care service. We help you develop
                                        effective marketing strategies, strengthen referral relationships, improve service visibility, and enhance resident
                                        experiences to increase enquiries and occupancy rates.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreCQ4}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Img5} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Staff Training</h2>
                                    <p>A well-trained workforce is the foundation of excellent care. We deliver engaging and practical training programmes
                                        tailored to the needs of care providers, helping staff develop the skills, knowledge, and confidence required to
                                        provide safe, effective, and person-centred care.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreCQ5}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Img6} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Contact Us</h2>
                                    <p>Whether you are starting a new service, preparing for an inspection, improving compliance, or seeking ongoing support,
                                        our experienced team is here to help. Contact us today to discuss your requirements and discover how we can support your
                                        organisation in achieving excellence in care.</p>
                                        <button className="OurServices-btn" onClick={handleSeeMore}>Read More</button>
                                      
                                </div>
                            </section>
                        </div>
                    </div>
            </div>
       </div>
      )}
      {activeSection === "care-home-sales" && (
              <div className="detail-content" id="care-home-sales">
                  <div className="Support-page">
                    <div className="Support-card">
                        <h1 className="Support-title">Care Home Sales</h1>
                        <div className="Support-container">

                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={care1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Care Homes for Sale</h2>
                                    <p>Explore a wide range of care homes available for purchase across the UK. Whether you are an experienced operator 
                                      looking to expand your portfolio or a first-time buyer entering the care sector, we provide expert guidance throughout the
                                        acquisition process. Our team helps identify suitable opportunities, conduct due diligence, and support successful transactions.</p>
                                       <button className="OurServices-btn" onClick={handleReadMoreCA1}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={care2} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Looking to Sell a Care Home</h2>
                                    <p>Selling a care home is a significant decision that requires expert support and a strategic approach. We help care 
                                      home owners achieve the best possible outcome by providing professional valuations, market insights, and confidential sales 
                                      management. From preparing your business for sale to identifying qualified buyers and negotiating offers, our team guides you through every
                                        stage of the process, ensuring a smooth, efficient, and successful transaction.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreCA1}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Img3} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Contact Us</h2>
                                    <p>Ready to take the next step? Whether you're looking to buy a care home, sell an existing service, or need expert 
                                      guidance to achieve your business goals, our experienced team is here to help. Get in touch today for a confidential discussion
                                        and discover how we can support your journey with professional advice, practical solutions, and dedicated support every step of the way.</p>
                                       <button className="OurServices-btn" onClick={handleSeeMore}>Read More</button>
                                </div>
                            </section>        
                    </div>
                  </div>
                </div>
              </div>
      )}
      {activeSection === "accounting" && (
              <div className="detail-content" id="accounting">
                  <div className="Support-page">
                    <div className="Support-card">
                        <h1 className="Support-title">Accounting</h1>
                        <div className="Support-container">

                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Acco1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>End of Year Accounts</h2>
                                    <p>Ensure your annual accounts are prepared accurately and submitted on time. We provide clear, compliant financial statements
                                        that help you understand your business performance and meet all reporting requirements with confidence.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreAC1}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Acco2} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Payroll</h2>
                                    <p>Take the stress out of managing employee wages, tax deductions, pensions, and compliance. Our payroll service ensures your
                                        staff are paid correctly and on schedule while keeping your business aligned with current regulations.</p>
                                       <button className="OurServices-btn" onClick={handleReadMoreAC2}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Acco3} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Capital Allowances</h2>
                                    <p>Maximise the tax relief available on qualifying business assets and property investments. We identify eligible expenditure
                                        and help you claim the allowances you're entitled to, improving cash flow and reducing tax liabilities.</p>
                                       <button className="OurServices-btn" onClick={handleReadMoreAC3}>Read More</button>
                                </div>
                            </section>
                              <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Acco4} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Financial Analysis and Support</h2>
                                    <p>Gain valuable insights into your business finances with expert analysis and practical guidance. We help you understand key
                                        financial indicators, improve profitability, manage costs, and make informed strategic decisions for sustainable growth.</p>
                                        <button className="OurServices-btn" onClick={handleReadMoreAC4}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Img6} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Contact Us</h2>
                                    <p>Ready to strengthen your financial management and achieve greater business success? Contact our team today for tailored accounting 
                                      and advisory support designed to help your business thrive.</p>
                                      <button className="OurServices-btn" onClick={handleSeeMore}>Read More</button>
                                </div>
                            </section>
                        </div>
                    </div>
            </div>
              </div>
      )}
      {activeSection === "software" && (
              <div className="detail-content" id="software">
                  <div className="Support-page">
                    <div className="Support-card">
                        <h1 className="Support-title">Software</h1>
                        <div className="Support-container">

                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Soft1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Total Care Rota</h2>
                                    <p>Simplify workforce scheduling with our intelligent rota management solution. Total Care Rota helps care providers efficiently 
                                      manage staff shifts, improve coverage, reduce administrative workload, and ensure the right people are in the right place at the right time.</p>
                                       <button className="OurServices-btn" onClick={handleReadMoreSoft1}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Soft2} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Governance Software</h2>
                                    <p>Strengthen compliance and operational oversight with our comprehensive governance platform. Monitor performance, manage policies,
                                        track actions, and maintain clear accountability across your organisation, helping you meet regulatory requirements with confidence.</p>
                                      <button  className="OurServices-btn" onClick={handleReadMoreSoft2}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Soft3} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Care Audit Software</h2>
                                    <p>Enhance quality assurance through a streamlined auditing process. Our Care Audit Software enables providers to conduct inspections,
                                        track findings, monitor improvements, and maintain accurate records that support continuous service excellence.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreSoft3}>Read More</button>
                                </div>
                            </section>
                              <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Soft4} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Our ERP System</h2>
                                    <p>Bring all your business operations together in one integrated platform. Our ERP System helps manage key functions including staffing, 
                                      compliance, finance, reporting, and performance monitoring, providing real-time insights and improved operational efficiency.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreSoft4}>Read More</button>
                                </div>
                            </section>
                              <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Soft5} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Capital allowances</h2>
                                    <p>Capital allowances are a form of tax relief that allows a business to deduct 
                                      the cost of certain capital assets from its taxable profits over time. These 
                                      assets may include machinery, equipment, vehicles, computers, and some
                                      building-related expenditures.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreSoft5}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Img5} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Contact Us</h2>
                                    <p>Discover how our innovative software solutions can transform the way you manage your care service. Contact us today to arrange a
                                        demonstration and find the right technology to support your organisation's growth and compliance goals.</p>
                                       <button className="OurServices-btn" onClick={handleSeeMore}>Read More</button>
                                </div>
                            </section>
                        </div>
                    </div>
            </div>
              </div>
      )}
      {activeSection === "operational-management" && (
              <div className="detail-content" id="operational-management">
                  <div className="Support-page">
                    <div className="Support-card">
                        <h1 className="Support-title">Operational Management</h1>
                        <div className="Support-container">
                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Opra1} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>New Business Set Up</h2>
                                    <p>Starting a care business requires careful planning, regulatory compliance, and a strong operational foundation.
                                        We provide expert guidance throughout the entire setup process, helping you establish policies, procedures, registrations, 
                                        and systems that position your business for long-term success.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreOpra1}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section reverse">
                                <div className="Support-image">
                                    <img src={Opra2} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Full Operational Management</h2>
                                    <p>Focus on growing your business while we help manage the day-to-day operations. Our comprehensive operational
                                        management service supports staffing, compliance, quality assurance, performance monitoring, and strategic planning
                                        to ensure your service runs efficiently and delivers outstanding care.</p>
                                      <button className="OurServices-btn" onClick={handleReadMoreOpra1}>Read More</button>
                                </div>
                            </section>
                            <section className="Support-section">
                                <div className="Support-image">
                                    <img src={Img3} alt="" />
                                </div>
                                <div className="Support-box">
                                    <h2>Contact Us</h2>
                                    <p>Whether you're launching a new care service or looking for expert operational support, our team is here to help.
                                        Get in touch today to discuss your goals and discover how our tailored solutions can support your business every step of the way.</p>
                                     <button className="OurServices-btn" onClick={handleSeeMore}>Read More</button>
                                </div>
                            </section>
                        </div>
                    </div>
            </div>
              </div>
      )}
    </section>
  );
};

export default Services;